import { Component, Input } from '@angular/core';

import { CheckCLESettings } from 'src/app/CLE/_core/models/cle-check.models';
import {
  NEW_MEMBER_BONUS_COURSE_TITLE,
  newMemberBonusCourseIds
} from 'src/app/CLE/_shared/utils/new-member-bonus-courses';

@Component({
  selector: 'app-cle-courses-list',
  templateUrl: './cle-courses-list.component.html',
  styleUrls: ['./cle-courses-list.component.scss']
})
export class CleCoursesListComponent {
  @Input() title: string = 'Courses Attended';
  @Input() courses: any[] = [];
  @Input() cardClass: string = '';
  @Input() showFee: boolean = true;

  // Opt-in totals row shown above the list (e.g. "Total CLE hours taken for 2026-2027").
  // Sums the raw hours of the listed courses — earned only, no carry-in.
  @Input() showTotals: boolean = false;
  @Input() totalsLabel: string = 'Total CLE hours taken';

  // CheckCLE settings supply the new-member bonus course ids; those rows show as
  // "New Members Bonus CLE Hours" with no sponsor. Without settings every row shows as stored.
  @Input() set settings(value: CheckCLESettings | null | undefined) {
    this.bonusCourseIds = newMemberBonusCourseIds(value);
  }

  private bonusCourseIds = new Set<number>();

  isBonusCourse(course: any): boolean {
    return this.bonusCourseIds.has(Number(course?.courseId));
  }

  courseTitle(course: any): string {
    return this.isBonusCourse(course) ? NEW_MEMBER_BONUS_COURSE_TITLE : course?.courseTitle;
  }

  get totalsCle(): number {
    return this.sum(c => c?.totalCle);
  }

  get totalsEthics(): number {
    return this.sum(c => c?.ethics ?? c?.sumOfEthics);
  }

  get totalsProf(): number {
    return this.sum(c => c?.prof ?? c?.sumOfProf);
  }

  private sum(pick: (course: any) => number | null | undefined): number {
    return (this.courses || []).reduce((total, course) => total + (Number(pick(course)) || 0), 0);
  }
}
